import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { currentTheme, selectTheme } from './theme/ThemeUtils';
import { getUserId, isFreeAccount } from "./utils/Utils";
import { UserContext } from './context/UserContext';  // Import the context

// Components
import TabButtons from './commands/TabButtons';
import AddContents from './add/AddContents';
import BasicGrid from './components/grid/Grid'; // This is the "Create Montage/Curate" component

import TrialAccountSnackbar from './utils/TrialAccountSnackBar';
import { ThemeProvider } from '@mui/material/styles';

function App() {
  const { t } = useTranslation();
  const theme = selectTheme();
  const [section, setSection] = useState('basicGrid'); // Default section is 'basicGrid'

  const sessionId = getUserId();
  console.log('[CreateMontage App] sessionId', sessionId);
  const wpLoggedIn = document.getElementById('root-create-montage').dataset.wpLoggedIn === 'true'; // Retrieve the WP login status
  const isLoggedIn = !!sessionId; // Checks if the user is logged in
  const isDemoAccount = isFreeAccount(); // Checks if the user is on a free/demo account
  const isGuest = isDemoAccount && !wpLoggedIn;

  const isUserLoggedIn = isLoggedIn && !isDemoAccount; // Refined logic
  console.log('[CreateMontage App] isUserLoggedIn, isDemoAccount, wpLoggedIn', isUserLoggedIn, isDemoAccount, wpLoggedIn);

  // Conditionally render the component based on the section state
  let ComponentToRender;
  switch (section) {
    case 'addContents':
      ComponentToRender = AddContents; // Renders the AddContents section
      break;
    default: // Default is 'basicGrid', which is the "Create Montage/Curate" section
      ComponentToRender = BasicGrid;
      break;
  }

  return (
    <ThemeProvider theme={theme}>
      {/* Wrap the app with UserContext.Provider and provide isUserLoggedIn */}
      <UserContext.Provider value={{ isGuest }}>
        {isDemoAccount && <TrialAccountSnackbar isGuest={isGuest} theme={currentTheme()} />}

        {/* Render the TabButtons component */}
        <TabButtons t={t} setSection={setSection} />
        
        {/* Conditionally render the selected component */}
        <ComponentToRender className="rootMontageElement" />
      </UserContext.Provider>
    </ThemeProvider>
  );
}

export default App;

export const sessionId = getUserId();